import { createSlice } from "@reduxjs/toolkit";
import {
  addCrop,
  addGrade,
  updateCrop,
  updateGrade,
  deleteCrop,
  deleteGrade,
  getCrops,
  getGrades,
  getVarieties,
  updateVariety,
  deleteVariety,
  addVariety,
} from "./actions/cropVariety";

const initialState = {
  loading: false,
  isEditing: false,
  crops: null,
  totalCrops: 0,
  crop: null,
  varieties: null,
  totalVarieties: 0,
  variety: null,
  grades: null,
  totalGrades: 0,
  grade: null,
};

export const cropVarietylice = createSlice({
  name: "cropVariety",
  initialState,
  reducers: {
    setCrop: (state, action) => {
      const crop = state.crops.find((loc) => loc.id === action.payload);
      state.crop = crop;
    },
    setVariety: (state, action) => {
      const variety = state.varieties.find((loc) => loc.id === action.payload);
      state.variety = variety;
    },
    setGrade: (state, action) => {
      const grade = state.grades.find((loc) => loc.id === action.payload);
      state.grade = grade;
    },
    setIsEditing: (state, action) => {
      state.isEditing = action.payload;
    },
  },
  extraReducers: (builder) => {
    // crops
    builder
      .addCase(getCrops.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCrops.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.crops = data;
        state.totalCrops = count;
      })
      .addCase(getCrops.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(addCrop.pending, (state) => {
        state.loading = true;
      })
      .addCase(addCrop.fulfilled, (_, action) => {
        window.location.hash = "#/profile/cropVariety?type=crop";
      })
      .addCase(addCrop.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateCrop.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCrop.fulfilled, (state, action) => {
        state.isEditing = false;
        state.crop = action.payload;
      })
      .addCase(updateCrop.rejected, (state, action) => {
        state.isEditing = false;
        state.loading = false;
      });

    builder.addCase(deleteCrop.fulfilled, (_, action) => {
      window.location.hash = "#/profile/cropVariety?type=crop";
    });

    // varieties
    builder
      .addCase(getVarieties.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVarieties.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.varieties = data;
        state.totalVarieties = count;
      })
      .addCase(getVarieties.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(addVariety.pending, (state) => {
        state.loading = true;
      })
      .addCase(addVariety.fulfilled, (_, action) => {
        window.location.hash = "#/profile/cropVariety?type=variety";
      })
      .addCase(addVariety.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateVariety.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateVariety.fulfilled, (state, action) => {
        state.isEditing = false;
        state.variety = action.payload;
      })
      .addCase(updateVariety.rejected, (state, action) => {
        state.isEditing = false;
        state.loading = false;
      });

    builder.addCase(deleteVariety.fulfilled, (_, action) => {
      window.location.hash = "#/profile/cropVariety?type=variety";
    });

    // grades
    builder
      .addCase(getGrades.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGrades.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.grades = data;
        state.totalGrades = count;
      })
      .addCase(getGrades.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(addGrade.pending, (state) => {
        state.loading = true;
      })
      .addCase(addGrade.fulfilled, (_, action) => {
        window.location.hash = "#/profile/cropVariety?type=grade";
      })
      .addCase(addGrade.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateGrade.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updateGrade.fulfilled, (state, action) => {
        state.isEditing = false;
        state.grade = action.payload;
      })
      .addCase(updateGrade.rejected, (state, action) => {
        state.isEditing = false;
        state.loading = false;
      });

    builder.addCase(deleteGrade.fulfilled, (_, action) => {
      window.location.hash = "#/profile/cropVariety?type=grade";
    });
  },
});

export const { setCrop, setVariety, setGrade, setIsEditing } =
  cropVarietylice.actions;

export default cropVarietylice.reducer;
